<template>
  <div>
    <mdb-modal
      v-if="confirmuser === null"
      id="modalOTP"
      :show="checkOTP"
      centered
    >
      <mdb-modal-header :close="false">
        <mdb-modal-title>
          <h4 class="font500 text-dark pl-2">ระบบยืนยันตัวตน</h4>
        </mdb-modal-title>
      </mdb-modal-header>
      <div class="row justify-content-center mt-3">
        <div
          class="col-5 text-center mt-2"
          @click="confirmuser = 'phone_confirm'"
          v-if="check_status === 1"
        >
          <!-- <i class="fas fa-mobile-alt fa-8x blue-text" style="cursor:pointer;"></i> -->
          <img
            src="/images/otp/sms2.png"
            class="mx-2"
            width="100%;"
            style="max-width: 120px; cursor: pointer"
          />
          <div class="text-dark font14 font600 p-2" style="cursor: pointer">
            คลิกเพื่อยืนยันผ่าน OTP
          </div>
        </div>
        <div class="col-5 text-center mt-2" v-if="check_status === 0">
          <a :href="alert_line" target="_blank">
            <!-- <i
              class="fab fa-line fa-9x text-success"
              style="cursor: pointer"
            ></i> -->
            <img
              src="/images/otp/line2.png"
              class="mx-2"
              width="100%;"
              style="max-width: 120px; cursor: pointer"
            />
            <div class="color_white font14 font600 p-2" style="cursor: pointer">
              ยืนยันผ่าน LINE
            </div>
          </a>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-10 text-center pt-2 pb-4">
          <mdb-btn class="btn-check" block @click="checkLinesub()"
            >ตรวจสอบการยืนยัน</mdb-btn
          >
        </div>
        <!-- <div class="text-center text-white font14 my-3">
					หากเกิดปัญหา ให้ติดต่อแอดมินทาง
					<a :href="contact_line" target="_blank">
						<span class="text-success font600">LINE คลิ๊ก</span>
					</a>
				</div> -->
      </div>
    </mdb-modal>
    <mdb-modal v-if="confirmuser === 'phone_confirm'" :show="checkOTP" centered>
      <mdb-modal-header :close="false">
        <mdb-modal-title class="mx-1 text-dark font500"
          >ยืนยันผ่าน OTP</mdb-modal-title
        >
        <mdb-modal-title :end="true">
          <i
            class="fas fa-arrow-alt-circle-left fa-1-5x text-dark mx-1 mt-1"
            style="cursor: pointer"
            @click="confirmuser = null"
          />
        </mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="mx-4 mb-3">
        <div v-if="!counting">
          <div class="font16 text-dark mt-2">หมายเลขโทรศัพท์</div>
          <input
            v-model="confirm_phonenumber"
            class="form-control mt-2 color_orange font600"
            disabled
            style="font-size: 1.1rem !important"
            type="text"
            label="กรอกเบอร์โทรศัพท์"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
          />
        </div>
        <div v-if="counting">
          <div class="row font16 text-dark mt-2">
            <div class="col-5">หมายเลข OTP</div>
            <div class="col-7 text-right">
              <countdown
                v-if="counting"
                :time="60000"
                :leading-zero="false"
                @end="countdownend()"
              >
                <template class="text-secondary" slot-scope="props"
                  >สิ้นสุดยืนยัน {{ props.totalSeconds }} วินาที</template
                >
              </countdown>
            </div>
          </div>
          <div class="row justify-content-center mt-3 pb-2">
            <div style="display: inline-block" class="text-center">
              <v-otp-input
                ref="otpInput"
                input-classes="otp-input"
                separator
                :num-inputs="6"
                :should-auto-focus="true"
                :is-input-num="true"
                @on-change="handleOnChange"
                @on-complete="handleOnComplete"
              />
              <!-- <button @click="handleClearInput()">Clear Input</button> -->
            </div>
          </div>

          <!-- <input
            v-model="confirm_OTP"
            class="form-control mt-2"
            type="text"
            label="กรอกเบอร์โทรศัพท์"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
          />-->
        </div>
        <!-- <div class="font14 text-white mt-4">
					<span class="font600">หากไม่ได้รับ OTP ผ่าน SMS ที่ส่งไปยังมือถือของคุณ ภายใน 60 วินาที กรุณาแอดไลน์ เพื่อติดต่อพนักงาน</span>
					<a :href="contact_line" target="_blank">
						<span class="text-success font600 font16"> LINE คลิ๊ก</span>
					</a>
				</div> -->
        <div class="text-right">
          <mdb-btn
            type="submit"
            class="btn-otp mt-4 mx-0 px-3 py-2 font500"
            :disabled="counting"
            @click="OTP()"
            v-if="!counting"
          >
            <span class="text-white font600">ขอรหัส OTP</span>
          </mdb-btn>

          <!-- <mdb-btn
            type="submit"
            :disabled="btnsubmit"
            :class=" btnsubmit === false ? 'btn-confirm-number mt-4 px-3 py-2' : 'disabled btn-confirm-number mt-4 px-3 py-2'"
            v-if="counting"
            @click="phonenumber()"
          >ยืนยัน OTP</mdb-btn>-->
        </div>
      </mdb-modal-body>
    </mdb-modal>
  </div>
</template>

<script>
const jwt = require("jsonwebtoken");
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import $ from "jquery";
export default {
  data() {
    return {
      confirmuser: null,
      btnsubmit: true,
      confirm_phonenumber: null,
      useractive: null,
      confirm_OTP: "",
      counting: null,
      check_status: "",
      contact_line: this.$link_linecontact,
      alert_line: this.$link_linealert,
    };
  },
  computed: {
    ...mapGetters({
      isLogin: "isLogin",
      user: "user",
      amount: "amount",
      token: "token",
    }),
    checkOTP: function() {
      if (this.useractive == 2) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    ...mapActions({
      storeLogin: "login",
      storeLoout: "logout",
      callApiMotherFucker: "callApiMotherFucker",
    }),
    handleOnChange(value) {
      console.log("OTP changed: ", value);
    },
    // handleClearInput() {
    //   this.$refs.otpInput.clearInput();
    // },
    checkLinesub() {
      $(".preloader").show();
      this.callApiMotherFucker({
        method: "get",
        path: "/is_login",
        data: {},
      }).then((res) => {
        let response = jwt.decode(res); // jwt_decode(res) ถอดรหัส res จาก is_ligin
        console.log("response", response);
        if (response.results[0].status_user == 2) {
          this.$swal({
            icon: "warning",
            title: "การยืนยันตัวตน",
            html: "คุณยังไม่ได้ยืนยันตัวตน !!",
            timer: 5000,
            showConfirmButton: true,
          });
        } else {
          this.$swal({
            icon: "success",
            title: "การยืนยันตัวตน",
            text: "คุณยืนยันตัวตนสำเร็จ !!",
            timer: 3000,
            showConfirmButton: true,
          }).then((result) => {
            if (result) {
              location.reload();
            }
          });
        }
      });
    },
    OTP() {
      let payload = {
        phone_number: this.confirm_phonenumber,
      };
      this.callApiMotherFucker({
        method: "post",
        path: "/otp",
        data: payload,
      }).then((res) => {
        console.log(res.code);
        if (res.code == 1) {
          this.$swal({
            icon: "warning",
            title: "เกิดข้อผิดพลาด",
            text: res.msg,
            timer: 5000,
            showConfirmButton: true,
          });
        } else {
          this.$swal({
            icon: "success",
            title: "สำเร็จ",
            html:
              "ระบบได้ส่งรหัส OTP ไปยัง <br> หมายเลข " +
              this.confirm_phonenumber +
              " เรียบร้อยแล้ว",
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
          this.counting = true;
          this.btnsubmit = false;
        }
      });
    },
    countdownend: function() {
      this.counting = false;
      this.btnsubmit = true;
    },
    handleOnComplete(value) {
      this.verifyOTP(value);
    },
    verifyOTP(value) {
      let payload = {
        phone_number: this.confirm_phonenumber,
        otp: value,
      };
      this.callApiMotherFucker({
        method: "post",
        path: "/otp_verify",
        data: payload,
      }).then((res) => {
        console.log(res.code);
        if (res.code == 0) {
          this.$swal
            .fire({
              icon: "success",
              title: "ยืนยันสำเร็จ",
              text: res.msg,
              timer: 3000,
              showConfirmButton: false,
            })
            .then((result) => {
              if (result) {
                location.reload();
              }
            });
        } else {
          this.$swal({
            icon: "error",
            title: "เกิดข้อผิดพลาด",
            text: "รหัส OTP ไม่ถูกต้อง",
            timer: 3000,
            showConfirmButton: true,
          });
        }
      });
    },
  },
  async mounted() {
    await this.callApiMotherFucker({
      method: "get",
      path: "/is_login",
      data: {},
    }).then((res) => {
      let response = jwt.decode(res);
      this.useractive = response.results[0].status_user;
      this.confirm_phonenumber = response.results[0].phone_number;
    });
    axios.get("https://auth-mode.firebaseio.com/SMS.json").then((response) => {
      this.check_status = response.data.status;
    });
  },
};
</script>

<style>
.btn-check {
  background: linear-gradient(180deg, #f5904b 0%, #ff6700 100%) !important;
  border-radius: 4px;
  padding: 5px 15px 6px 15px;
  /* border: 1px solid #e233ff; */
  color: #ffffff;
  font-size: 20px;
}
.btn-check:hover {
  background: linear-gradient(180deg, #f5904b 0%, #ff6700 100%) !important;
  border-radius: 4px;
  padding: 5px 15px 6px 15px;
  /* border: 1px solid #e233ff; */
  color: #ffffff;
}
.fa-1-5x {
  font-size: 1.3em;
}
.btn-otp {
  background: linear-gradient(180deg, #f5904b 0%, #ff6700 100%) !important;
  border-radius: 5px;
  color: #131313;
  font-size: 16px;
}
.btn-otp:hover {
  color: #131313;
}
.btn-confirm-number {
  background: linear-gradient(180deg, #f5904b 0%, #ff6700 100%) !important;
  border-radius: 5px;
  color: #131313;
  font-size: 16px;
}
.btn-confirm-number:hover {
  color: #131313;
}
/*----------------- OTP INPUT ------------------*/
.otp-input {
  background: linear-gradient(180deg, #ffa263 0%, #ff6700 100%) !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  color: #ffffff;
  width: 40px;
  height: 50px;
  padding: 5px;
  margin: 5px;
  font-size: 24px;
  border: 0px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}
</style>
